/*
 * product-extras.js
 * Custom elements para a seção "Informações do produto":
 *  - <payment-installments>: pop-up de parcelas, recalcula com o preço da variante atual.
 *  - <product-tabs>: abas (uma visível por vez).
 * Mantém o padrão Dawn: um arquivo, custom elements, sem bundler/imports.
 */

if (!customElements.get('payment-installments')) {
  customElements.define(
    'payment-installments',
    class PaymentInstallments extends HTMLElement {
      constructor() {
        super();
        this.price = parseInt(this.dataset.price, 10) || 0;
        this.max = parseInt(this.dataset.max, 10) || 12;
        this.noInterestLabel = this.dataset.noInterest || '';
        this.cashLabel = this.dataset.cashLabel || '';
        this.currency = this.dataset.currency || 'BRL';
        this.locale = this.dataset.locale || 'pt-BR';
        try {
          this.pcts = JSON.parse(this.dataset.pcts || '[]');
        } catch (e) {
          this.pcts = [];
        }
        this.list = this.querySelector('[data-installments-list]');
      }

      connectedCallback() {
        this.render();
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event?.data?.variant;
          if (variant && typeof variant.price === 'number') {
            this.price = variant.price;
            this.render();
          }
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
          }).format(cents / 100);
        } catch (e) {
          return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
        }
      }

      render() {
        if (!this.list) return;
        let rows = '';
        for (let n = 1; n <= this.max; n++) {
          const pct = parseFloat(this.pcts[n - 1]) || 0;
          const total = Math.round(this.price * (1 + pct / 100));
          const perInstallment = Math.round(total / n);
          const isFree = pct === 0;

          let label;
          if (n === 1) {
            label = `${this.cashLabel} ${this.formatMoney(total)}`.trim();
          } else {
            const note = isFree
              ? this.noInterestLabel
              : `(${this.formatMoney(total)} no total)`;
            label = `${n}x de ${this.formatMoney(perInstallment)} ${note}`.trim();
          }

          rows += `<li class="payment-installments__row${isFree ? ' payment-installments__row--free' : ''}">
            <span class="payment-installments__count">${n}x</span>
            <span class="payment-installments__value">${label}</span>
          </li>`;
        }
        this.list.innerHTML = rows;
      }
    }
  );
}

if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.tab));
        });
      }

      activate(id) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.tab === id;
          tab.classList.toggle('product-tabs__button--active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          panel.toggleAttribute('hidden', panel.dataset.panel !== id);
        });
      }
    }
  );
}
